import platform from '@propertypal/shared/src/utils/platform';
import React from 'react';
import { Bold, Text } from '../typography';
import { ContactAgentBox, Container, TextBox } from './ContactAgentExample.style';

const ContactAgentExample = () => {
  return (
    <Container>
      <TextBox>
        <Text fontSize={platform.select(16, 21)} lineHeight={26}>
          <Bold>
            As {platform.title} is not an estate agent, we can&apos;t help with any of the particulars about a property.
          </Bold>
        </Text>
        <br />
        <Text fontSize={platform.select(16, 21)} lineHeight={26}>
          <Bold>If you have a query, each property has a contact form where you can contact the agent directly.</Bold>
        </Text>
      </TextBox>
      <ContactAgentBox />
    </Container>
  );
};

export default ContactAgentExample;
